
import { load } from "../loaders/basic-loader";


export const TagColors = ["success", "warning", "info", "danger", "primary", "dark"] as const
export type TagColor = typeof TagColors[number];

export type Tag = {
    id: number
    name: string
    color: string
    franchise?:number
}


export async function listTags(franchises:number[]){
    const result = await load("tags/list", {}, {franchises})
    return result.tags as Record<string, Tag[]>
}

export async function addTag(tag:Tag){
    const result = await load("tags", {}, {tag})
    return result.tag as Tag
}

export async function replaceTags(account:number, tags:number[]){
    const result = await load("tags/replace", {}, {account, tags})
    return result.result == 'ok'
}

export async function deleteTag(id:number){
    const result = await load("tags/" + id, {}, null, "delete")
    return result.result == 'ok'
}

export async function updateTag(tag:Tag){
    const result = await load(`tags/${tag.id}`, {}, {tag})
    return result.tag as Tag
}

